import type {
  Field,
  FormField,
  FormState,
  ImageChoiceOption,
  UploadedFileType
} from '../contexts';

const FIELDS_WITH_SELECT = ['choice', 'imageChoice', 'dropdown'];

const HTML_ESCAPE_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;'
} as const;

const getSelectValue = (
  fields: FormField[],
  id: string,
  value: Field['value']
) => {
  const baseField = fields.find((el) => el.id === id);
  const option = baseField?.options?.find(({ id }) => id === value);

  if (baseField?.type === 'imageChoice' && option) {
    return escapeHTML(option.name || (option as ImageChoiceOption).index);
  }

  return escapeHTML(option?.name || value);
};

function escapeHTML(val: unknown) {
  if (typeof val !== 'string') {
    return val;
  }

  return val.replace(
    /[&<>]/g,
    (c) => HTML_ESCAPE_MAP[c as keyof typeof HTML_ESCAPE_MAP]
  );
}

export function formattingText(
  text: string,
  baseFields: FormField[],
  changedFields: FormState['fields']
) {
  return Object.entries(changedFields).reduce((text, [id, fieldData]) => {
    const { value, fieldID, type } = fieldData;
    let updatedValue;

    if (FIELDS_WITH_SELECT.includes(type)) {
      if (Array.isArray(value)) {
        updatedValue = value
          .map((item) => getSelectValue(baseFields, id, item as string))
          .join(', ');
      } else {
        updatedValue = getSelectValue(baseFields, id, value);
      }
    }

    if (type === 'file') {
      if (Array.isArray(value)) {
        updatedValue = (value as UploadedFileType[])
          .map(
            (file) =>
              `<a href="${file.uploaded}" target="_blank">${file.name}</a>`
          )
          .join(', ');
      } else {
        updatedValue = null;
      }
    }

    if (type === 'URL' && value) {
      updatedValue = `<a href="${value}">${value}</a>`;
    }

    if (type === 'consent' && !value) {
      updatedValue = 'No';
    }

    if (!updatedValue) {
      updatedValue = Array.isArray(value)
        ? value.map(escapeHTML).join(', ')
        : (escapeHTML(value) ?? '');
    }

    return text.replaceAll(`[${fieldID}]`, `${updatedValue}`);
  }, text);
}
